const footer = {
  props: {
    dynamicClass: "footer.dynamicLoading",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-footer.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document,
      $breadcrumbFooter = baseFind.querySelector("footer .breadcrumb"),
      $breadcrumbHeader = baseFind.querySelector(":not(footer) .breadcrumb");

    if (!$breadcrumbFooter && !$breadcrumbHeader) {
      return;
    }

    if ($breadcrumbFooter) {
      $breadcrumbFooter.removeChild($breadcrumbFooter.children[0]);
      $breadcrumbHeader.children[0] && $breadcrumbFooter.appendChild($breadcrumbHeader.children[0].cloneNode(true));
    }
  },
};

export default footer;
